export default [
  {
    path: '*',
    name: 'QueryHome',
    meta: {
      title: '质保查询'
    },
    component: () => import('@/views/query')
  }, {
    path: '/order-list',
    name: 'OrderList',
    meta: {
      title: '我的订单'
    },
    component: () => import('@/views/order')
  }, {
    path: '/order-product',
    name: 'OrderProduct',
    meta: {
      title: '订单商品'
    },
    component: () => import('@/views/order-product')
  }, {
    path: '/evaluate',
    name: 'Evaluate',
    meta: {
      title: '评价'
    },
    component: () => import('@/views/evaluate')
  }, {
    path: '/evaluate-detail',
    name: 'EvaluateDetail',
    meta: {
      title: '我的评价'
    },
    component: () => import('@/views/evaluate-detail')
  }, {
    path: '/warranty-detail',
    name: 'WarrantyDetail',
    meta: {
      title: '质保信息'
    },
    component: () => import('@/views/warranty-detail')
  }, {
    path: '/after-sale',
    name: 'AfterSale',
    meta: {
      title: '申请售后',
      type: 'after-sales'
    },
    component: () => import('@/views/after-sale')
  }, {
    path: '/insurance',
    name: 'Insurance',
    meta: {
      title: '申请膜险',
      type: 'insurance'
    },
    component: () => import('@/views/after-sale')
  }
]